var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.configModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "txtRemark",
          staticStyle: { height: "6%", width: "99%" },
          on: {
            dblclick: function($event) {
              return _vm.onTxtRemarksDoubleClick()
            }
          }
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.txtRemarks,
                expression: "txtRemarks"
              }
            ],
            staticStyle: {
              width: "100%",
              "margin-left": "10px",
              height: "100%"
            },
            attrs: {
              disabled: true,
              title: _vm.$t("Pricing.RemarkAreaToolTip")
            },
            domProps: { value: _vm.txtRemarks },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.txtRemarks = $event.target.value
              }
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }